export default "__VITE_ASSET__d7ptRHmQ__"